import { render } from "./Transactions.vue?vue&type=template&id=60a0e550&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=60a0e550&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a0e550"]])

export default __exports__